import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';

import { AuthService } from './auth.service';

@Injectable()
export class APIService {
    //private baseUrl: string = 'http://localhost:8080/tesco-api';
    private baseUrl: string = '../api';
    
    constructor(
        private authService: AuthService,
        private http: Http
    ) {}

    private createObservable(route: string, request: string = 'GET', postParams: any = null): Observable<any> {
        let url = this.baseUrl + route;
        let observable;
        switch(request) {
            case 'GET':
                observable = this.http.get(url)
                break;
            case 'POST':
                observable = this.http.post(url, postParams)
                break;
            default:
                break;
        }

        return observable.map(response => {
            return response.json();
        });
    }

    public login(code: string): Observable<any> {
        return this.createObservable('/auth.php', 'POST', {code: code});
    }

    public command(command: string, value: number, testMode: boolean): Observable<any> {
        let postParams = {
            command: command,
            value: value,
            test: testMode
        };

        return this.createObservable('/control.php?key=' + this.authService.authKey, 'POST', postParams);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/api.service.ts